<template>
  <a-card>
    <div class="main-panel" style="height: 800px">
      <div class="main-title-wrap">
        <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }" :colon="false">
          <a-row :gutter="20">
            <a-col :span="22">
              <a-row :gutter="20">
                <a-col :span="10">
                  <a-form-model-item label="客户名称">
                    <a-input v-model="customName" auto-complete="off" placeholder="请输入客户名称" clearable></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="客户状态">
                    <a-select v-model="customBind" filterable placeholder="请选择客户状态" :clearable="true">
                      <a-select-option
                        v-for="item in bindStatus"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item label="">
                    <a-button type="primary" icon="el-icon-search" @click="search">搜索</a-button>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col :span="2">
                <a-row :gutter="20">
                  <a-col :span="8">
                      <a-button type="link" @click="addBizCompany()" v-has="'COMPANY_ADD'">
                        添加
                      </a-button>
                  </a-col>
                  <a-col :span="16">
                      <a-dropdown trigger="click" v-has="'COMPANY_UP'">
                        <span class="el-dropdown-link">
                           <a-button type="link" icon="el-icon-upload2">导入导出</a-button>
                        </span>
                        <a-menu slot="overlay">
                          <a-menu-item icon="el-icon-upload">
                            <a-upload
                              action="/api/biz-companys/import"
                              @change="handleSuccess"
                              :before-upload="beforeAvatarUpload"
                              :showUploadList="false">
                              <span>上传文件</span>
                            </a-upload>
                          </a-menu-item>
                          <a-menu-item icon="el-icon-download" @click="exportExcel">下载文件
                          </a-menu-item>
                          <a-menu-item icon="el-icon-document-copy" @click="downloadExcel">下载模板
                          </a-menu-item>
                        </a-menu>
                      </a-dropdown>
                  </a-col>
                </a-row>
            </a-col>
          </a-row>
        </a-form-model>

      </div>
      <div class="main-content-wrap">
        <a-row>
          <a-col :span="24">
            <a-table
              :loading="table.loading"
              :data-source="table.data"
              :default-sort="table.sort"
              :pagination="table.pagination"
              @change="handleTableChange"
              ref="table.dataRef">
              <a-table-column
                align="center"
                :sorter="true"
                key="number"
                data-index="number" title="客户号" width="120">
              </a-table-column>
              <a-table-column
                align="center"
                :sorter="true"
                key="name"
                data-index="name" title="客户名称" width="120">
              </a-table-column>
              <a-table-column
                align="center"
                :sorter="true"
                key="statusStr"
                data-index="statusStr" title="客户状态" width="120">
              </a-table-column>
              <a-table-column
                align="center"
                :sorter="true"
                key="createAt"
                data-index="createAt" title="创建时间" width="120">
              </a-table-column>
              <a-table-column
                align="center"
                :sorter="true"
                key="updatedAt"
                data-index="updatedAt" title="更新时间" width="120">
              </a-table-column>
              <a-table-column
                align="center"
                :sorter="true"
                key="date"
                data-index="date" title="操作" width="120">
                <template slot-scope="text, record">
                  <a-button type="link" v-has="'COMPANY_EDIT'" @click="editBizCompany(record)">编辑
                  </a-button>
                  <a-button type="link" v-has="'COMPANY_DELETE'" @click="deleteBizCompany(record)">删除
                  </a-button>
                </template>
              </a-table-column>
            </a-table>
          </a-col>
        </a-row>
      </div>
    </div>
    <a-modal
      :title="form.data.id===null||form.data.id===''?'新增客户':'编辑客户'"
      v-model="form.visible" @cancel="onFormCancel" @ok="onFormSave">
      <biz-company-edit
        width="600px"
        ref="companyEdit"
        v-if="form.visible"
        :biz-company-id="form.data.id"
        :on-cancel-handler="onFormCancel"
        :get-biz-company-list="getBizCompanyList"
        :on-submit-handler="onFormSave">
      </biz-company-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryBizCompanys,
  _deleteBizCompany,
  _queryBizCompanyList,
} from '../../../api/bizCompanyApi';
import BizCompanyEdit from './BizCompanyEdit.vue';
import {getTime} from '../../../utils/dateUtil';
import {delArea} from "../../../api/area";


async function getBizCompanyList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascending' ? 'ASC' : 'DESC';
  }
  const result = await _queryBizCompanys({
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    // sort: this.table.sort.prop,
    direction,
    customName: this.customName,
    bindStatus: this.customBind,
  });
  const data = result.data.bizCompanys;
  this.table.data = data.map(x => ({
    ...x,
    statusStr: x.size > 0 ? '绑定' : '未绑定'
  }))
  this.table.pagination.total = result.data.totalAmount;
}

function addBizCompany() {
  this.form.data.id = '';
  this.form.visible = true;
}

function editBizCompany(bizCompany) {
  this.form.data.id = bizCompany.id;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getBizCompanyList();
}

async function deleteBizCompany(bizCompany) {
  let that = this;
  this.$confirm({
    title: '是否删除这条数据?',
    content: '',
    okType: 'danger',
    async onOk() {
      const result = await _deleteBizCompany(bizCompany.id);
      if (result.code === 1200) {
        that.$message.success('删除成功')
        await that.getBizCompanyList();
      }
    },
    //   this.onCancel()
    onCancel() {
    },
    class:
      'test',
  });

}

/**
 * 显示条目数
 * @param val
 */
function handleSizeChange(val) {
  this.listQuery.size = val;
  this.getBizCompanyList();
}

/**
 * 当前页
 * @param val
 */
function handleCurrentChange(val) {
  this.listQuery.page = val;
  this.getBizCompanyList();
}

/**
 * 文件上传之前的回调函数
 */
function beforeAvatarUpload(file) {
//        判断上传文件的后缀 是否为 xls 或 xlsx 格式
  const index = file.name.lastIndexOf('.');
  const fileName = file.name.substring(index + 1);
  if (fileName !== 'xls' && fileName !== 'xlsx') {
    let that = this;
    this.$confirm({
      title: '上传文件必须为 .xls 或 .xlsx 格式 ?',
      content: '',
      okType: 'warning',
      onOk() {
        that.form.dialogVisibleWorker = false;
      },
      //   this.onCancel()
      onCancel() {
        that.form.dialogVisibleWorker = false;
      },
      class:
        'test',
    });
    // this.$confirm('上传文件必须为 .xls 或 .xlsx 格式 ', '提示', {
    //   confirmButtonText: '确定',
    //   cancelButtonText: '取消',
    //   type: 'warning',
    // }).catch(() => {
    //   //                关闭批量上传弹窗
    //   this.form.dialogVisibleWorker = false;
    // });
    return false;
  }
}

function handleSuccess(res) {
  let that = this;
  // setTimeout(() => {
    if (this.uploadTrue){
      if (res.file.response && res.file.response.code === 1200) {
        that.$message.success('上传成功');
        this.getBizCompanyList();
      }
    } else {
      this.uploadTrue = !this.uploadTrue
    }

  // }, 1000)
}

function exportExcel() {
  require.ensure([], () => {
    const { export_json_to_excel } = require("../../../utils/Export2Excel");
    const tHeader = ["客户号", "客户名称"];
    // 上面设置Excel的表格第一行的标题
    const filterVal = ["number", "name"];
    // 上面的index、nickName、name是tableData里对象的属性
    const list = this.excelData; //把data里的tableData存到list
    const data = this.formatJson(filterVal, list);
    export_json_to_excel(tHeader, data, "客户配置导出" + getTime());
  });
}

function formatJson(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => v[j]));
}

async function downloadExcel() {
  this.$confirm({
    title: '是否下载客户配置导入模板.xlsx？',
    content: '',
    okType: 'warning',
    onOk() {
      window.location.href = '/api/signForImg/客户配置导入模板.xlsx';
      // that.$message.success('上传成功');
    },
    //   this.onCancel()
    onCancel() {
      // that.form.dialogVisibleWorker = false;
    },
    class:
      'test',
  });
  // this.$confirm('是否下载客户配置导入模板.xlsx？', '提示', {
  //   type: 'warning',
  //   confirmButtonText: '确认',
  //   cancelButtonText: '取消'
  // }).then(async () => {
  //   // window.location.href = "http://localhost:8099/signForImg/导入运费和计费重量模板.xlsx";
  //   window.location.href = '/api/signForImg/客户配置导入模板.xlsx';
  // });
}

function search() {
  this.table.pagination.current = 1;
  this.getBizCompanyList();
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  this.table.sort = {
    prop: sorter.field,
    order: sorter.order,
  };
  this.getBizCompanyList();
}

export default {
  name: 'BizCompanyList',
  components: { BizCompanyEdit },
  data() {
    return {
      // companyTitle: '',
      uploadTrue: true,
      customBind: '',
      customName: '',
      excelData: [],
      bindStatus: [{ value: 0, name: "未绑定" }, { value: 1, name: "绑定" }],
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '40', '50'],
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        },
        sort: {
          prop: 'createAt',
          order: 'descend',
        },
      },
    };
  },
  methods: {
    getBizCompanyList,
    deleteBizCompany,
    editBizCompany,
    addBizCompany,
    // closeForm,
    handleSizeChange,
    handleCurrentChange,
    beforeAvatarUpload,
    handleSuccess,
    exportExcel,
    formatJson,
    downloadExcel,
    search,
    handleTableChange,
    onFormSave() {
      this.form.visible = false;
      this.$refs.companyEdit.submit();
      // this.getBizCompanyList();
      // this.form = {};
      this.form.id = '';
    },
    onFormCancel() {
      this.form.visible = false;
      this.getBizCompanyList();
      this.form.id = '';
    }
  },
  async created() {
    this.getBizCompanyList();
    const direction = 'DESC';
    const result = await _queryBizCompanyList();
    this.excelData = result.data.bizCompanys;
  },
};
</script>

<style scoped>

</style>
